import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { UserAvatar } from "@/components/UserAvatar";

export default function SiteHeader() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-30 backdrop-blur-xl bg-[hsl(var(--background))]/85 border-b border-black/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="site-logo-link" className="flex items-center gap-2.5">
          <div className="w-7 h-7 bg-foreground text-background grid place-items-center font-serif-display text-lg font-black leading-none">D</div>
          <span className="font-serif-display text-xl tracking-tight">DocuMind</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <a href="/#features" className="hover:text-primary">Features</a>
          <a href="/#pricing" className="hover:text-primary">Pricing</a>
          <Link to="/compare" data-testid="nav-compare" className="hover:text-primary">Compare</Link>
          <a href="/#faq" className="hover:text-primary">FAQ</a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <UserAvatar name={user.name} picture={user.picture} testId="header-user-avatar" />
              <Button variant="ghost" size="sm" data-testid="nav-dashboard" onClick={() => nav('/app')}>Dashboard</Button>
              <Button variant="outline" size="sm" data-testid="nav-logout" onClick={() => { logout(); nav('/'); }}>Log out</Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login" className="text-sm hover:text-primary hidden sm:inline">Log in</Link>
              <Link to="/signup" data-testid="nav-signup">
                <Button size="sm" className="bg-foreground text-background hover:bg-primary rounded-sm btn-invert">
                  Start free
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
